import {
  GET_UNLEASHDETAILS_FAILURE,
  GET_UNLEASHDETAILS_REQUEST,
  GET_UNLEASHDETAILS_SUCCESS
} from 'constants/actionTypes';
const initialState = {
  unleashDetails: null,
  isLoading: false,
  error: null
};

export const getUnleashDetails = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_UNLEASHDETAILS_REQUEST:
      return {
        ...state,
        unleashDetails: null,
        isLoading: true,
        error: null
      };
    case GET_UNLEASHDETAILS_SUCCESS:
      return {
        ...state,
        unleashDetails: payload.flags,
        isLoading: false,
        error: null
      };
    case GET_UNLEASHDETAILS_FAILURE:
      return {
        ...state,
        unleashDetails: null,
        isLoading: false,
        error: payload.message
      };

    default:
      return state;
  }
};
